// src/components/Wheel.js
import React, { useState, useEffect, useRef } from 'react';
import Winwheel from 'winwheel';
import { gsap } from 'gsap';
import { TextField, Button} from '@mui/material';
const Wheel = () => {
    const [names, setNames] = useState([]);
    const [nameInput, setNameInput] = useState('');
    const canvasRef = useRef(null);
    let wheel;

    useEffect(() => {
        // Incluir GSAP en Winwheel
        window.gsap = gsap;

        if (names.length > 0) {
            const segments = names.map(name => ({
                'fillStyle': getRandomColor(),
                'text': name
            }));

            wheel = new Winwheel({
                'canvasId': canvasRef.current.id,
                'numSegments': names.length,
                'segments': segments,
                'animation': {
                    'type': 'spinToStop',
                    'duration': 5,
                    'spins': 8,
                    'callbackFinished': alertPrize
                }
            });

            // Habilitar giro al hacer clic o tocar la rueda
            canvasRef.current.addEventListener('click', handleSpin);
            canvasRef.current.addEventListener('touchstart', handleSpin);
        }

        return () => {
            // Limpiar los eventos al desmontar el componente
            if (canvasRef.current) {
                canvasRef.current.removeEventListener('click', handleSpin);
                canvasRef.current.removeEventListener('touchstart', handleSpin);
            }
        };
    }, [names]);

    const handleSpin = () => {
        wheel.startAnimation();
    };

    const alertPrize = () => {
        const winningSegment = wheel.getIndicatedSegment();
        alert("Ganador: " + winningSegment.text);
    };

    const handleInputChange = (event) => {
        setNameInput(event.target.value);
    };

    const handleAddName = () => {
        if (nameInput.trim() !== '') {
            setNames([...names, nameInput.trim()]);
            setNameInput('');
        }
    };

    const handleKeyPress = (event) => {
        if (event.key === 'Enter') {
            event.preventDefault();
            handleAddName();
        }
    };

    const getRandomColor = () => {
        const letters = '0123456789ABCDEF';
        let color = '#';
        for (let i = 0; i < 6; i++) {
            color += letters[Math.floor(Math.random() * 16)];
        }
        return color;
    };

    return (
        <div style={{overflowY:"hidden", height:"700px"}}>
            <h1>Ruleta de Nombres</h1>
            <div style={{ display: 'flex', alignItems: 'baseline' }}>
            <TextField
                    id="outlined-basic"
                    label="Nombre"
                    variant="outlined"
                    value={nameInput}
                    onChange={handleInputChange}
                    onKeyPress={handleKeyPress}
                    placeholder="Ingresa un nombre"
                    sx={{ flex: '1', marginRight: '10px', height: "30px" }} // Ajustar la altura aquí
                />
                <Button
                    onClick={handleAddName}
                    variant="contained"
                    sx={{
                        background: "#333333",
                        ":hover": { background: "#333333" },
                        height: '100%' // Igualamos la altura al TextField
                    }}
                >
                    Agregar Nombre
                </Button>
            </div>
            {names.length > 0 && (
                <div style={{ position: 'relative', display: 'inline-block', marginTop: "50px", marginBottom: "50px" }}>
                    <canvas ref={canvasRef} id="myWheel" width="300" height="300"></canvas>
                    <div style={indicatorStyle}></div>
                </div>
            )}
          
        </div>
    );
};


const indicatorStyle = {
    position: 'absolute',
    top: '50%',
    right: '-8px',
    width: '0px',
    height: '0px',
    borderTop: '20px solid transparent', // Altura del triángulo aumentada
    borderBottom: '20px solid transparent', // Altura del triángulo aumentada
    borderRight: '50px solid red', // Ancho de la base del triángulo ajustado
    transform: 'translateY(-50%)',
};

export default Wheel;
